
import { onBeforeMount, ref } from 'vue';
import PreviewThought from '@/components/news/PreviewThought.vue';
import { domainStore } from '@/store/domain-store';
import { projectStore } from '@/store/project-store';
import thoughtRepository from '@/api/thoughtRepository';
import { IThought } from '@/models/thought.model';
import Message from 'primevue/message';
// eslint-disable-next-line
//@ts-ignore
import VueLoading from '@/components/general/Loading';
import { IGenericFilter } from '@/models/filter.model';

export default {
  name: 'NewsProjectPreview',
  components: { PreviewThought, Message, VueLoading },
  props: {
    domainid: {
      type: Number,
      required: true,
    },
    projectid: {
      type: Number,
      required: true,
    },
    numThoughts: {
      type: Number,
      default: 3,
    },
    moreLink: {
      type: String,
      required: true,
    },
    thoughtListHeight: {
      type: Number,
      default: 600,
    },
  },

  setup(props: any) {
    //REF
    const thoughts = ref<IThought[] | null>([]);
    const isLoading = ref<boolean>(true);
    const errorMsg = ref<IGenericFilter>({
      severity: 'info',
      content: '',
    });
    const fetchParams = ref<IGenericFilter>({
      sort: `-publication_date`,
      rows: props.numThoughts,
      projectid: props.projectid,
      page: 1,
    });

    //METHODS
    function redirectToAllThoughts() {
      window.location.href = props.moreLink;
    }

    //LIFEHOOKS
    onBeforeMount(() => {
      isLoading.value = true;
      domainStore.setDomainId(props.domainid);
      projectStore.setProjectId(props.projectid, false);
      thoughtRepository
        .get(fetchParams.value)
        .then((fetchedThoughts: any) => {
          thoughts.value = fetchedThoughts.data;
          errorMsg.value.content = '';
        })
        .catch(error => {
          console.log(error);
          errorMsg.value.severity = 'error';
          errorMsg.value.content = 'News konnten nicht geladen werden';
        })
        .finally(() => {
          isLoading.value = false;
        });
    });

    return {
      // REFS
      thoughts,
      errorMsg,
      isLoading,
      // METHODS
      redirectToAllThoughts,
    };
  },
};
